import * as cart from '@shopify/theme-cart';
import {formatMoney} from '@shopify/theme-currency';


$('input').change(function() {
  const currentQuantity = parseInt($(this).val(), 10);
  const minValue = parseInt($(this).attr('min'), 10);
  // If the max attribute doesn't exist for the item, should return false.
  const maxValue = parseInt($(this).attr('max'), 10);
  const key = $(this).attr('id').split('_', 2)[1];
 // console.log('aaa');
  //console.log(`Input for ${key}`);

  if (currentQuantity === minValue) {
    cart.removeItem(key).then(state => {
      console.log('This item was removed');
      updateCartTotals($(this), currentQuantity, 0, state.total_price);
      removeCartRow($(this).closest('.cart_form_row'));
    });
  } else if (!maxValue) {
    cart.updateItem(key, {quantity: currentQuantity}).then(state => {
      const currentItem = state.items.find(item => item.key === key);
      //console.log(`The item with key '${key}' now has quantity ${currentItem.quantity} and a price of ${currentItem.price}`);
      //$(this).closest('tr.d-md-table-row').find('.line_item_total').text(`$${(currentItem.line_price / 100).toFixed(2)}`)
      $(this).closest('.cart_form_row').find('.line_item_total').text(formatMoney( currentItem.line_price, window.moneyFormat))
      updateCartTotals($(this), currentItem.quantity, currentItem.price, state.total_price);
    });
  } else if (currentQuantity <= maxValue) {
    cart.updateItem(key, {quantity: currentQuantity}).then(state => {
      const currentItem = state.items.find(item => item.key === key);
      //console.log(`The item with key '${key}' now has quantity ${currentItem.quantity}`);
      //$(this).closest('tr.d-md-table-row').find('.line_item_total').text(`$${(currentItem.line_price / 100).toFixed(2)}`)
      $(this).closest('.cart_form_row').find('.line_item_total').text(formatMoney( currentItem.line_price, window.moneyFormat))
      updateCartTotals($(this), currentItem.quantity, currentItem.price, state.total_price);
    });
  } else {

  }
});

$('.qty_input').bind('input', function () {
  const currentQuantity = parseInt($(this).val(), 10);
  const minValue = parseInt($(this).attr('min'), 10);
  const maxValue = parseInt($(this).attr('max'), 10);
  const key = $(this).attr('id').split('_', 2)[1];
  if (currentQuantity > maxValue) {
    $(this).css('border-color', 'red').delay(400).queue(function(next){
     $(this).css('border-color', '#ced4da');
     $(this).val(maxValue);
     next();
   });
  }
});

function updateCartTotals(thisObj, itemPrice, quantity, subtotal) {
  const itemTotal = ((itemPrice * quantity) / 100).toFixed(2);
  thisObj.parents().eq(1).children("td.cart-money[data-label='Total']")
  .text(`$${itemTotal}`);
  $('#subtotal').text(formatMoney( subtotal, window.moneyFormat));
}

function removeCartRow(thisObj) {
  thisObj.parents().eq(1).remove();
}

$('.quantity-right-plus').click(function(e){
  e.preventDefault();
  var curr_qty = parseInt($(this).closest('.qty_group').find('.qty_input').val());
  var qty_max = parseInt($(this).closest('.qty_group').find('.qty_input').attr('max'));
  var working_input = $(this).closest('.qty_group').find('.qty_input');
  if (curr_qty < qty_max) {
    working_input.val(curr_qty + 1).change();
  } else {
    var original_color = working_input.css('border-color');
    working_input.css('border-color', 'red').delay(400).queue(function(next){
     working_input.css('border-color', '#ced4da');
     next();
   });


  }

});

$('.quantity-left-minus').click(function(e){
  e.preventDefault();
  var curr_qty = parseInt($(this).closest('.qty_group').find('.qty_input').val());
  if (curr_qty >= 1) {
    $(this).closest('.qty_group').find('.qty_input').val(curr_qty - 1).change();
  }

});